import { composeIO } from 'react-compose-io'
import { fieldsCondicaoTransformacaoApiIO } from './FieldsCondicaoTransformacaoApi.IO'
import { FieldsCondicaoTransformacaoApiView } from './FieldsCondicaoTransformacaoApi.View'

export const FieldsCondicaoTransformacaoApi = composeIO(FieldsCondicaoTransformacaoApiView, fieldsCondicaoTransformacaoApiIO)
